function groupBrandsByFirstLetter() {
    const container = document.querySelector('.brands-list__container');

    // Check if the container is found on the page
    if (!container) {
//        console.error('Container not found on the page.');
        return;
    }

    const brandNames = document.querySelectorAll('.brand-name');

    // Brands generated from collections arrive in collection order, not in display order
    const isAuto = !!container.closest('[data-brands-auto]');

    // Create an object to group brands by their first letter
    const groupedBrands = {};

    brandNames.forEach((brand) => {
        let firstLetter = brand.innerText.charAt(0).toUpperCase();

        if (isAuto) {
            // textContent: the list is still hidden at this point; accents are dropped so "�" falls under "E"
            firstLetter = brand.textContent.trim().charAt(0).normalize('NFD').charAt(0).toUpperCase();
        }

        if (groupedBrands[firstLetter]) {
            groupedBrands[firstLetter].push(brand.closest('.swiper-slide'));
        } else {
            groupedBrands[firstLetter] = [brand.closest('.swiper-slide')];
        }
    });

    // Sort the grouped brands alphabetically
    const sortedKeys = Object.keys(groupedBrands).sort();

    // Sort the brands inside each letter, ignoring case and accents
    if (isAuto) {
        const brandTitle = (slide) => slide.querySelector('.brand-name').textContent.trim();
        sortedKeys.forEach((key) => {
            groupedBrands[key].sort((a, b) => brandTitle(a).localeCompare(brandTitle(b), 'pt', { sensitivity: 'base' }));
        });
    }

    // Clear the container
    container.innerHTML = '';

    // Rebuild the container with sorted and grouped brands
    sortedKeys.forEach((key) => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('brand-group','mt-6', 'flex', 'flex-wrap', '-mx-2', 'xl:-mx-3');

        const letterHeader = document.createElement('div');
        letterHeader.classList.add('brand-letter', 'container-fluid');
        letterHeader.innerText = key;

        // Add the data-letter-anchor attribute to the letter header
        letterHeader.setAttribute('data-letter-anchor', `letter${key}`);

        wrapper.appendChild(letterHeader);
        groupedBrands[key].forEach((brand, index) => {
            // Add the data-letter-anchor attribute to each brand
            brand.setAttribute('data-letter-anchor', `letter${key}${index + 1}`);
            wrapper.appendChild(brand);
        });

        // Add the id attribute to the section
        wrapper.setAttribute('id', `letterAnchor${key}`);
        container.appendChild(wrapper);
    });

    // Set opacity 0.5 to letters without a group
    const alphabetLetters = document.querySelectorAll('.alphabet li');
    alphabetLetters.forEach((letter) => {
        const letterAnchor = letter.getAttribute('onclick').replace("scrollToAnchor('letter", '').replace("');", '');
        if (!groupedBrands[letterAnchor]) {
            letter.querySelector('span').classList.add('inactive');
        }
    });
}

// Fetch the other pages of a brands list generated from collections (Liquid paginates collections by 250 at most)
function loadRemainingBrandPages(section) {
    const wrapper = section.querySelector('[data-wrapper]');
    const currentPage = parseInt(wrapper.dataset.currentPage, 10) || 1;
    const totalPages = parseInt(wrapper.dataset.pages, 10) || 1;
    const requests = [];

    for (let page = 1; page <= totalPages; page++) {
        if (page === currentPage) continue;

        // Section Rendering API: same page, same section, another page of collections
        const url = new URL(window.location.href);
        url.searchParams.set('page', page);
        url.searchParams.set('section_id', section.dataset.sectionId);

        requests.push(
            fetch(url.toString())
                .then((response) => {
                    if (!response.ok) throw new Error(`Brands page ${page}: ${response.status}`);
                    return response.text();
                })
                .then((html) => {
                    const doc = new DOMParser().parseFromString(html, 'text/html');
                    return Array.from(doc.querySelectorAll('[data-wrapper] > .swiper-slide'));
                })
                .catch((error) => {
                    // Keep the brands already on the page if one request fails
                    console.error(error);
                    return [];
                })
        );
    }

    return Promise.all(requests).then((pages) => {
        pages.forEach((slides) => slides.forEach((slide) => wrapper.appendChild(slide)));
    });
}

function initBrandsList() {
    const section = document.querySelector('.brands-list[data-brands-auto]');

    if (!section) {
        groupBrandsByFirstLetter();
        return;
    }

    // Group only after every page is in, then reveal the list
    loadRemainingBrandPages(section)
        .catch(console.error)
        .then(() => {
            groupBrandsByFirstLetter();
            section.classList.remove('brands-list--loading');
        });
}

// Call the function once the DOM is ready
document.addEventListener('DOMContentLoaded', initBrandsList);

// Theme editor: the section is rendered again without the grouping
document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.brands-list[data-brands-auto]')) initBrandsList();
});

// Function to scroll to the corresponding section with the letter anchor
function scrollToAnchor(anchorId) {
    const targetSection = document.querySelector(`[data-letter-anchor="${anchorId}"]`);
    if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}

// Add event listeners to each letter element
const letters = document.querySelectorAll('.alphabet li');
letters.forEach(letter => {
    letter.addEventListener('click', function() {
        const anchorId = this.getAttribute('onclick').match(/'([^']+)'/)[1];
        scrollToAnchor(anchorId);
    });
});


window.addEventListener("load", function() {
    var element = document.getElementById('app-wrapper-template--22983529398606__1711463202b5b6a195');
    if (element) {
        element.style.height = 'auto';
        element.style.overflow = '';
    }
});







